import moment from "moment";
import React from "react";

const TimeSelector = ({ disabledTimes, onTimeSelect }) => {
  // Example list of time slots. You can adjust this based on your actual data.
  
    const generateTimeSlots = (start, end) => {
      const startTime = moment(start, "HH:mm");
      const endTime = moment(end, "HH:mm");
      const timeSlots = [];
  
      while (startTime <= endTime) {
        timeSlots.push(startTime.format("HH:mm")); // Including seconds to match your initial format
        startTime.add(30, "minutes");
      }
  
      return timeSlots;
    };
    const availableTimes = generateTimeSlots("09:00", "17:30");


  // Function to convert 12-hour format time to 24-hour format for comparison
  const convertTime12to24 = (time) => {
    const [hour, minute, period] = time.split(/[:\s]/);
    let newHour = parseInt(hour, 10);
    if (period === "PM" && newHour < 12) {
      newHour += 12;
    }
    if (period === "AM" && newHour === 12) {
      newHour = 0;
    }
    return `${newHour.toString().padStart(2, "0")}:${minute}:00`;
  };

  // Check if the time is disabled based on the disabledTimes prop
  const isTimeDisabled = (time) => {
    const formattedTime = convertTime12to24(time);
    return disabledTimes[formattedTime] !== undefined;
  };

  return (
    <div className="justify-content-center align-items-center">
      <div className="m-auto d-flex flex-wrap gap-1 justify-content-center align-items-center " style={{ width:"70%" }}>
        {availableTimes.map((time) => (
          <button
            key={time}
            className={`card time-slot ${isTimeDisabled(time) ? "disabled" : ""}`}
            style={{
              width: "110px",
              height: "50px",
              cursor: isTimeDisabled(time) ? "not-allowed" : "pointer",
              opacity: isTimeDisabled(time) ? 0.5 : 1,
            }}
            onClick={() => !isTimeDisabled(time) && onTimeSelect(time)}
            disabled={isTimeDisabled(time)}
          >
            <div className="card-body">{time}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeSelector;
